<div
  class="container-comparator mb-9"
  [ngClass]="{
    container: visibleIncentiveCount < 5,
    'container-full': visibleIncentiveCount >= 5
  }"
>
  <div class="container" *ngIf="visibleIncentiveCount && !loading">
    <div class="columns">
      <div class="column is-12">
        <nav class="level is-mobile is-flex mt-0 mb-2">
          <div class="level-left">
            <div class="level-item">
              <span [ngPlural]="visibleIncentiveCount">
                <ng-template ngPluralCase="=1">
                  <p class="content is-small has-text-weight-bold">
                    {{ visibleIncentiveCount }} incentive
                  </p></ng-template
                >
                <ng-template ngPluralCase="other">
                  <p class="content is-small has-text-weight-bold">
                    {{ visibleIncentiveCount }} incentives in comparison
                  </p>
                </ng-template>
              </span>
            </div>
          </div>
          <div class="level-right">
            <div
              class="level-item is-hidden-mobile has-tooltip has-tooltip-top has-tooltip-multiline"
              data-tooltip="The OECD median reflects the design and implementation of the typical R&D tax incentive scheme (middlemost observation) in the OECD area. The calculation of the OECD median, carried out for binary and ordinal policy variables, is based on all active R&D tax incentives in OECD countries. In the case of nominal policy variables (e.g. type of tax instrument), the OECD mode (most frequent observation) is computed and reported instead."
            >
              <label
                class="checkbox is-flex is-align-items-center mr-2 content is-small"
              >
                <input
                  type="checkbox"
                  class="mr-1"
                  (change)="showOECDMedian = !showOECDMedian; initCarousel()"
                />
                Include OECD median
                <i
                  class="fa-solid fa-circle-info ml-1 is-size-6 has-text-info"
                ></i>
              </label>
            </div>
            <div
              class="level-item is-hidden-mobile has-tooltip has-tooltip-top has-tooltip-multiline"
              data-tooltip="The EU median reflects the design and implementation of the typical R&D tax incentive scheme (middlemost observation) in the EU-27 area. The calculation of the EU median, carried out for binary and ordinal policy variables, is based on all active R&D tax incentives in EU countries. In the case of nominal policy variables (e.g. type of tax instrument), the EU mode (most frequent observation) is computed and reported instead."
            >
              <label
                class="checkbox is-flex is-align-items-center mr-2 content is-small"
              >
                <input
                  type="checkbox"
                  class="mr-1"
                  (change)="showEUMedian = !showEUMedian; initCarousel()"
                />
                Include EU median
                <i
                  class="fa-solid fa-circle-info ml-1 is-size-6 has-text-info"
                ></i>
              </label>
            </div>
            <div class="level-item">
              <div class="field has-addons">
                <p class="control">
                  <a class="button is-small is-hidden-desktop">
                    <span class="icon is-small">
                      <i class="fa-solid fa-arrow-up-wide-short"></i>
                    </span>
                  </a>
                  <a
                    (click)="
                      isOrderIncentivesModalOpen = !isOrderIncentivesModalOpen
                    "
                    class="button is-small is-hidden-touch"
                    *ngIf="isOrderable && visibleIncentiveCount >= 3"
                  >
                    <span>Order incentives</span>
                    <span class="icon is-small">
                      <i class="fa-solid fa-arrow-up-wide-short"></i>
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </nav>
        <nav class="level is-mobile is-flex mb-2 is-hidden-tablet">
          <div class="level-right">
            <div class="level-item">
              <label
                class="checkbox is-flex is-align-items-center mr-2 content is-small pl-0"
              >
                <input
                  type="checkbox"
                  class="mr-1"
                  (change)="showOECDMedian = !showOECDMedian; initCarousel()"
                />
                Include OECD median
              </label>
            </div>
            <div class="level-item">
              <label
                class="checkbox is-flex is-align-items-center mr-2 content is-small pl-0"
              >
                <input
                  type="checkbox"
                  class="mr-1"
                  (change)="showEUMedian = !showEUMedian; initCarousel()"
                />
                Include EU median
              </label>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
  <div
    class="card has-border c-table content is-small"
    *ngIf="visibleIncentiveCount && !loading"
  >
    <div
      class="wrap index-{{ carouselIndex }}"
      [ngClass]="{ carousel: isCarouselActive }"
    >
      <a
        *ngIf="isCarouselActive && !isOrderIncentivesModalOpen"
        class="carousel-nav-left no-deco is-flex is-align-items-center is-justify-content-center has-background-primary"
        (click)="carouselIndex = carouselIndex - 1"
        [ngClass]="{ 'is-disabled': carouselIndex <= 0 }"
        ><i class="fa-solid fa-arrow-left has-text-light pr-1 is-size-6"></i
      ></a>
      <a
        *ngIf="isCarouselActive && !isOrderIncentivesModalOpen"
        class="carousel-nav-right no-deco is-flex is-align-items-center is-justify-content-center has-background-primary"
        (click)="carouselIndex = carouselIndex + 1"
        [ngClass]="{
          'is-disabled':
            carouselIndex + maxVisibleIncentives >= visibleIncentiveCount
        }"
        ><i class="fa-solid fa-arrow-right has-text-light pl-1 is-size-6"></i
      ></a>

      <!-- Incentives head -->
      <div class="is-flex c-row c-row--head">
        <div class="c-col is-static has-background-white"></div>
        <div class="results is-flex is-fullwidth">
          <ng-container *ngFor="let incentive of incentives">
            <div
              *ngIf="
                (incentive.id !== OECDmedianId &&
                  incentive.id !== EUmedianId) ||
                (incentive.id === OECDmedianId && showOECDMedian) ||
                (incentive.id === EUmedianId && showEUMedian)
              "
              class="c-col"
              [ngClass]="{
                'is-eu-median has-background-success-light':
                  incentive.id === EUmedianId,
                'is-oecd-median has-background-warning-light':
                  incentive.id === OECDmedianId,
                'is-disabled': incentive.isDisabled
              }"
            >
              <div
                class="is-flex is-align-items-flex-start is-justify-content-space-between"
              >
                <a
                  *ngIf="incentive.id !== 'NZL2'"
                  class="has-text-weight-bold pr-2 has-text-dark"
                  routerLink="/incentives/{{ incentive.id }}"
                  >{{ incentive.label }}</a
                >
                <a
                  *ngIf="incentive.id === 'NZL2'"
                  class="has-text-weight-bold pr-2 has-text-dark has-tooltip has-tooltip-bottom has-tooltip-multiline"
                  routerLink="/incentives/{{ incentive.id }}"
                  data-tooltip="The tax credit for research and development tax losses represents a concessionary loan against tax losses associated with R&D and thus differs from a standard R&D tax credit that provides a direct, non-repayable reduction in the amount of tax payable by business."
                  >{{ incentive.label }}</a
                >
                <a
                  *ngIf="allowDeleteIncentive"
                  (click)="removeIncentiveFromComparator(incentive.id)"
                >
                  <i
                    class="fa-solid fa-trash has-text-dark mt-1"
                    title="Remove from comparison"
                  ></i>
                </a>
              </div>
              <a
                class="is-flex is-align-items-center mt-2 mb-1 no-deco"
                routerLink="/countries/{{ incentive.country.id }}"
              >
                <img
                  class="flag is-small"
                  src="./assets/images/flags/{{ incentive.country.image }}.png"
                  alt="{{ incentive.country.label }} flag"
                />
                <a
                  class="ml-1 has-text-dark"
                  routerLink="/countries/{{ incentive.country.id }}"
                >
                  {{ incentive.country.label }}</a
                >
              </a>
              <app-favorite-button
                *ngIf="
                  isFavoriteButtonDisplayed &&
                  incentive.id !== EUmedianId &&
                  incentive.id !== OECDmedianId
                "
                [incentive]="incentive"
                [selectedFamily]="selectedFamily"
              ></app-favorite-button>
              <p
                *ngIf="
                  isShowSimilarDisplayed && incentive.similarIncentiveIds.length
                "
              >
                <a
                  routerLink="/incentives"
                  [queryParams]="{
                    similarTo: incentive.id
                  }"
                  class="is-flex is-align-items-flex-start is-justify-content-flex-start mt-1 no-deco has-text-link has-text-weight-bold has-tooltip has-tooltip-bottom has-tooltip-multiline"
                  data-tooltip="To facilitate policy search and analysis of R&D tax incentive schemes with similar design characteristics, the OECD has derived an exploratory and preliminary measure of the similarity of R&D tax incentive schemes. This measure, calculated for active R&D tax incentive schemes (central government level) in OECD countries and partner economies, provides a synthetic measure of the similarity of two R&D tax incentive schemes based on a set of key design features: the type of tax instrument, the taxability of R&D tax benefits, limitation of qualifying R&D expenditures or R&D tax benefits treatment of unused claims in the case of loss, availability of preferential tax relief provisions for SMEs or R&D collaboration, R&D definition (R&D activities and domains of R&D eligible for tax relief),and qualifying R&D expenditures."
                >
                  <i class="fa-solid fa-layer-group mr-1 similar-icon"></i>
                  Compare with similar incentives</a
                >
              </p>
            </div>
          </ng-container>
        </div>
      </div>

      <div id="accordion--categories">
        <ng-container *ngFor="let theme of themes; let isFirst = first">
          <div
            class="c-row c-row--category is-flex"
            *ngIf="mode !== Mode.CountryView"
          >
            <div class="c-col is-static has-background-grey-lighter">
              <div
                class="is-flex is-justify-content-space-between is-align-items-center"
              >
                <div class="is-flex is-align-items-center">
                  <a
                    class="has-text-dark"
                    (click)="theme.isCollapsed = !theme.isCollapsed"
                    *ngIf="!isFirst"
                    data-action="collapse"
                  >
                    <i
                      class="fa-solid mr-1"
                      [ngClass]="{
                        'fa-angle-down': theme.isCollapsed,
                        'fa-angle-up': !theme.isCollapsed
                      }"
                    ></i>
                  </a>
                  <span class="has-text-weight-bold">{{ theme.label }}</span>
                </div>
                <div
                  class="dropdown"
                  [ngClass]="{
                    'is-active': themeVisibilityDialogOpen === theme.id
                  }"
                >
                  <div class="dropdown-trigger">
                    <a class="pl-1" (click)="toggleThemeVisibility(theme.id)">
                      <i class="fa-solid fa-sliders has-text-dark"></i>
                    </a>
                  </div>
                  <div
                    class="dropdown-menu is-right"
                    id="dropdown-menu"
                    role="menu"
                  >
                    <div class="dropdown-content">
                      <div class="dropdown-item mb-2">
                        <p class="is-uppercase has-text-grey">
                          Display / hide {{ theme.label }} fields
                        </p>
                      </div>
                      <a
                        class="dropdown-item"
                        *ngFor="let field of theme.fields"
                        (click)="field.isHidden = !field.isHidden"
                        [ngClass]="{
                          'is-active': !field.isHidden
                        }"
                      >
                        <i
                          [ngClass]="{
                            'has-text-light': field.isHidden
                          }"
                          class="fa-solid fa-check mr-1"
                        ></i>
                        {{ field.label }}
                      </a>

                      <ng-container *ngIf="theme.subThemes">
                        <ng-container *ngFor="let subTheme of theme.subThemes">
                          <hr class="dropdown-divider" />
                          <div class="dropdown-item">
                            <p class="has-text-weight-bold">
                              {{ subTheme.label }}
                            </p>
                          </div>

                          <a
                            *ngFor="let subField of subTheme.fields"
                            (click)="subField.isHidden = !subField.isHidden"
                            class="dropdown-item"
                            [ngClass]="{
                              'is-active': !subField.isHidden
                            }"
                          >
                            <i
                              [ngClass]="{
                                'has-text-light': subField.isHidden
                              }"
                              class="fa-solid fa-check mr-1"
                            ></i>
                            {{ subField.label }}
                          </a>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="results is-flex is-fullwidth has-background-grey-lighter"
            >
              <ng-container *ngFor="let incentive of incentives">
                <div
                  class="c-col"
                  *ngIf="
                    (incentive.id !== OECDmedianId &&
                      incentive.id !== EUmedianId) ||
                    (incentive.id === OECDmedianId && showOECDMedian) ||
                    (incentive.id === EUmedianId && showEUMedian)
                  "
                ></div>
              </ng-container>
            </div>
          </div>

          <!-- Fields -->
          <div
            id="collapsible{{ theme.label }}"
            [ngClass]="{
              'is-active': !theme.isCollapsed,
              'is-collapsible': theme.label !== 'General'
            }"
          >
            <ng-container *ngFor="let field of theme.fields; let index = index">
              <div class="is-flex c-row" *ngIf="!field.isHidden">
                <div
                  class="c-col is-static has-background-white has-tooltip-right has-tooltip-multiline is-aligned-from-top"
                  [attr.data-tooltip]="field.description"
                >
                  <span>{{ field.label }}</span>
                </div>
                <div class="results is-flex is-fullwidth">
                  <ng-container *ngFor="let incentive of incentives">
                    <div
                      *ngIf="
                        (incentive.id !== OECDmedianId &&
                          incentive.id !== EUmedianId) ||
                        (incentive.id === OECDmedianId && showOECDMedian) ||
                        (incentive.id === EUmedianId && showEUMedian)
                      "
                      class="c-col is-flex is-align-items-flex-start is-justify-content-flex-start"
                      [ngClass]="{
                        'is-eu-median has-background-success-light':
                          incentive.id === EUmedianId,
                        'is-oecd-median has-background-warning-light':
                          incentive.id === OECDmedianId,
                        'is-disabled': incentive.isDisabled
                      }"
                    >
                      <div
                        class="cell-wrap {{ field.id }}-val"
                        *ngIf="incentive.values?.[field.id]"
                        #valueField
                      >
                        {{ incentive.values[field.id] }}
                        <span
                          class="has-tooltip has-tooltip-right has-tooltip-multiline has-tooltip-large"
                          [attr.data-tooltip]="
                            incentive.tooltipValues[field.id]
                          "
                          *ngIf="incentive.tooltipValues[field.id]"
                        >
                          <i
                            class="fa-solid fa-circle-info is-size-8 has-text-link ml-2"
                          ></i>
                        </span>
                        <a
                          class="reduce"
                          (click)="toggleExtendValue(field.id + '-val')"
                          >Reduce</a
                        >
                      </div>
                      <div
                        class="cell-wrap"
                        *ngIf="!incentive.values?.[field.id]"
                      >
                        -
                      </div>
                      <a
                        class="extend"
                        (click)="toggleExtendValue(field.id + '-val')"
                        >Extend</a
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <!-- SubThemes -->
            <ng-container *ngFor="let subTheme of theme.subThemes">
              <div
                class="is-flex c-row c-row--subcategory"
                *ngIf="
                  !subTheme.isHidden &&
                  hasVisibleSubFields(subTheme) &&
                  mode !== Mode.CountryView
                "
              >
                <div class="c-col is-static has-background-white-bis">
                  <div
                    class="is-flex is-justify-content-space-between is-align-items-center is-fullheight"
                  >
                    <strong class="is-size-8 is-uppercase">{{
                      subTheme.label
                    }}</strong>
                  </div>
                </div>
                <div
                  class="results is-flex is-fullwidth has-background-white-bis"
                >
                  <ng-container *ngFor="let incentive of incentives">
                    <div
                      class="c-col is-flex is-align-items-flex-start is-justify-content-flex-start"
                      *ngIf="
                        !subTheme.isHidden &&
                        hasVisibleSubFields(subTheme) &&
                        ((incentive.id !== OECDmedianId &&
                          incentive.id !== EUmedianId) ||
                          (incentive.id === OECDmedianId && showOECDMedian) ||
                          (incentive.id === EUmedianId && showEUMedian))
                      "
                      [ngClass]="{
                        'is-eu-median has-background-success-light':
                          incentive.id === EUmedianId,
                        'is-oecd-median has-background-warning-light':
                          incentive.id === OECDmedianId,
                        'is-disabled': incentive.isDisabled
                      }"
                    ></div>
                  </ng-container>
                </div>
              </div>

              <!-- SubFields -->
              <div *ngFor="let subField of subTheme.fields">
                <div class="is-flex c-row" *ngIf="!subField.isHidden">
                  <div
                    class="c-col is-static has-background-white has-tooltip-right has-tooltip-multiline is-aligned-from-top"
                    [attr.data-tooltip]="subField.description"
                  >
                    <span>{{ subField.label }}</span>
                  </div>
                  <div class="results is-flex is-fullwidth">
                    <ng-container *ngFor="let incentive of incentives">
                      <div
                        class="c-col is-flex is-align-items-flex-start is-justify-content-flex-start"
                        [ngClass]="{
                          'is-eu-median has-background-success-light':
                            incentive.id === EUmedianId,
                          'is-oecd-median has-background-warning-light':
                            incentive.id === OECDmedianId,
                          'is-disabled': incentive.isDisabled
                        }"
                        *ngIf="
                          (incentive.id !== OECDmedianId &&
                            incentive.id !== EUmedianId) ||
                          (incentive.id === OECDmedianId && showOECDMedian) ||
                          (incentive.id === EUmedianId && showEUMedian)
                        "
                      >
                        <div
                          class="cell-wrap {{ subField.id }}-val"
                          *ngIf="incentive.values?.[subField.id]"
                          #valueField
                        >
                          {{ incentive.values[subField.id] }}
                          <span
                            class="has-tooltip has-tooltip-right has-tooltip-multiline has-tooltip-large"
                            [attr.data-tooltip]="
                              incentive.tooltipValues[subField.id]
                            "
                            *ngIf="incentive.tooltipValues[subField.id]"
                          >
                            <i
                              class="fa-solid fa-circle-info is-size-8 has-text-link ml-2"
                            ></i>
                          </span>
                          <a
                            class="reduce"
                            (click)="toggleExtendValue(subField.id + '-val')"
                            >Reduce</a
                          >
                        </div>
                        <div
                          class="cell-wrap"
                          *ngIf="!incentive.values?.[subField.id]"
                        >
                          -
                        </div>
                        <a
                          class="extend"
                          (click)="toggleExtendValue(subField.id + '-val')"
                          >Extend</a
                        >
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    class="container"
    *ngIf="!loading && visibleIncentiveCount === 0 && showAdviceIfEmpty"
  >
    <div class="columns">
      <div class="column">
        <div class="card is-shadowless has-background-link-light is-empty">
          <div class="card-content">
            <div class="content">
              <div
                class="is-flex is-align-items-center is-justify-content-flex-start"
              >
                <i
                  class="fa-regular fa-folder-open is-size-4 is-primary-light mr-2"
                ></i>
                <h3 class="title is-4 my-0">
                  You have not selected any tax incentives for comparison
                </h3>
              </div>
              <ol>
                <li>
                  Explore and add tax incentives through the "Find incentives"
                  tab
                </li>
                <li>Select the incentives you want to compare</li>
                <li>
                  Take advantage of comparison interface of the OECD INNOTAX
                  portal to compare R&D tax incentives in OECD and partner
                  economies along the design parameters of interest to you.
                </li>
              </ol>
              <a routerLink="/incentives" class="button is-link"
                >Find incentives</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-incentive-comparator-loader
    *ngIf="loading"
  ></app-incentive-comparator-loader>
</div>

<app-order-incentives-modal
  [incentives]="incentives"
  *ngIf="isOrderIncentivesModalOpen"
  (onCloseModal)="onOrderChanged($event)"
></app-order-incentives-modal>
